function moduleAccordion() {
	/**
	 * Trigger window resize on accordion collapse
	 */
	$('.module.accordion .collapse').on('shown.bs.collapse', function () {
		$(window).resize();
	});
	/**
	 *  Accordion scroll animation
	 */
	$('.module.accordion.scroll-animation .collapse').on('shown.bs.collapse', function () {
		const positionTop = $(this).parent().offset().top; // - $('header').height();
		$('html, body').animate({
			scrollTop: positionTop,
		}, 500);
	});
}
